import { channel } from "@/broadcasting/recording";

type RecordingLocalStateEvent = {
  type: "recording-local-state-updated";
  recordingUUID: string;
};

type RecordingDurationEvent = {
  type: "recording-duration-updated";
  recordingUUID: string;
  duration: number;
};

type RecordingLocalStateListener = (event: RecordingLocalStateEvent) => void;
type RecordingDurationListener = (event: RecordingDurationEvent) => void;

export const emitRecordingLocalStateUpdated = (recordingUUID: string) => {
  channel.postMessage({
    event: "recording-local-state",
    type: "recording-local-state-updated",
    recordingUUID,
  });
};

export const emitRecordingDurationUpdated = (recordingUUID: string, duration: number) => {
  channel.postMessage({
    event: "recording-local-state",
    type: "recording-duration-updated",
    recordingUUID,
    duration,
  });
};

export const subscribeRecordingLocalStateUpdated = (listener: RecordingLocalStateListener): (() => void) => {
  const onMessage = (event: MessageEvent<unknown>) => {
    const data = event.data as Record<string, unknown>;
    if (data?.type !== "recording-local-state-updated") return;
    listener({ type: "recording-local-state-updated", recordingUUID: data.recordingUUID as string });
  };

  channel.addEventListener("message", onMessage);
  return () => {
    channel.removeEventListener("message", onMessage);
  };
};

export const subscribeRecordingDurationUpdated = (listener: RecordingDurationListener): (() => void) => {
  const onMessage = (event: MessageEvent<unknown>) => {
    const data = event.data as Record<string, unknown>;
    if (data?.type !== "recording-duration-updated") return;
    listener({
      type: "recording-duration-updated",
      recordingUUID: data.recordingUUID as string,
      duration: data.duration as number,
    });
  };

  channel.addEventListener("message", onMessage);
  return () => {
    channel.removeEventListener("message", onMessage);
  };
};
